import type { ModuleType } from '#types/global';

type MediaModule = {
	type?: ModuleType | null;
	audio?: {
		duration?: number | null;
	} | null;
	video?: {
		duration?: number | null;
	} | null;
};

export function getDurationFromMediaModule(mediaModule?: MediaModule | null) {
	if (!mediaModule) {
		return undefined;
	}

	switch (mediaModule.type) {
		case 'AUDIO':
			const audioDuration = mediaModule?.audio?.duration ?? undefined;

			if (!audioDuration) {
				return undefined;
			}

			return audioDuration;

		case 'VIDEO':
			const videoDuration = mediaModule?.video?.duration ?? undefined;

			if (!videoDuration) {
				return undefined;
			}

			return videoDuration;

		default:
			return undefined;
	}
}
